import moment from "moment";
import store from "../store/store";
import { EBINQUIRY, HEADER, USERPROFILEINPUT } from "./services-model.type";
import auth from 'app/shared/services/auth';

export const getDataHeaders = (messageID: string, action: string = "N", isLogin?: boolean): HEADER => {
  const sessionID = store.getState().config.sessionId;
  const hasKey = store.getState().account.hasKey;
  const headers: HEADER = {
    ACTION: action,
    MERCHANTID: "10101",
    MESSAGEID: messageID,
    CHANNEL: "IB",
    LANGUAGE: "VI",
    SYSTEMID: "E85A008768CCF2820549233FD8DE4904",
    SESSION_ID: sessionID,
    SYSTEM_DATE: moment().format("DD/MM/YYYY HH:mm:ss"),
  };
  if (hasKey) headers.HASKEY = hasKey;
  if (isLogin) headers.REFRESH_TOKEN = auth.re_token;
  return headers;
};

export const getUserHeader = (): USERPROFILEINPUT => {
  const state = store.getState();
  const accountProfile = state.account.USERPROFILE;
  const sessionID = state.config.sessionId;
  const userProfile: USERPROFILEINPUT = {
    SESSONDATE: moment().format("DD/MM/YYYY HH:mm:ss"),
    SESSIONID: sessionID,
    USERGROUPTYPE: accountProfile?.USERGROUPTYPE || "01",
  };
  if (accountProfile?.CIFNUMBER) {
    userProfile.CIFNUMBER = accountProfile.CIFNUMBER;
  }
  return userProfile;
};

export const getUserParam = (): EBINQUIRY => {
  const state = store.getState();
  const userProfile = state.account.USERPROFILE;
  const userParams: EBINQUIRY = {
    CBNV: userProfile?.CBNV,
    CIFNUMBER: userProfile?.CIFNUMBER,
    MOBILEAUTHORIZE: userProfile?.MOBILEAUTHORIZE,
    MOBILEDEFINITION: userProfile?.MOBILEDEFINITION,
    SESSONDATE: moment().format("DD/MM/YYYY HH:mm:ss"),
    USERGROUPTYPE: userProfile?.USERGROUPTYPE || "01",
  };
  return userParams;
};
